import React from "react";
import "../css/PrivacyModal.css";

const PrivacyModal = ({ isOpen, onClose }) => {

  if (!isOpen) return null;

  return (
    <div className="privacy_modal">

      <div className="privacy_modal_overlay" onClick={onClose}></div>

      <div className="privacy_modal_content">

        <button
          type="button"
          className="privacy_modal_close"
          onClick={onClose}
          aria-label="Cerrar política de privacidad"
        >
          ×
        </button>

        <h2>Política de privacidad</h2>

        <div className="privacy_modal_text">

          <p>
            Los datos personales que facilites a través de este formulario
            serán tratados únicamente con la finalidad de gestionar tu consulta,
            responder a tu mensaje y mantener la comunicación contigo en relación
            con el mismo.
          </p>

          <p>
            Los datos solicitados son los necesarios para poder identificarte
            y responder adecuadamente a tu solicitud.
          </p>

          <p>
            No utilizaremos tus datos para enviarte comunicaciones comerciales
            ni los cederemos a terceros, salvo que exista una obligación legal.
          </p>

          <p>
            Los datos se conservarán únicamente durante el tiempo necesario
            para atender y gestionar tu consulta y, posteriormente, durante
            los plazos legalmente establecidos cuando corresponda.
          </p>

          <p>
            Puedes solicitar el acceso, rectificación o supresión de tus datos,
            así como ejercer otros derechos reconocidos por la normativa aplicable,
            contactando a través de los datos de contacto disponibles en esta web.
          </p>

          <p>
            Al marcar la casilla correspondiente, confirmas que has leído
            y aceptas esta política de privacidad.
          </p>

        </div>

      </div>

    </div>
  );
};

export default PrivacyModal;